import React from 'react'

const NewLogoIcon = (
  <>
    <path
      d="M10.843 8.05911C6.66348 2.38097 -0.949923 5.30353 0.0981836 10.8777C1.14629 16.4518 9.25752 20.998 11.477 22.1026C13.7087 23.2132 14.7111 21.9517 14.7638 20.4084C14.8166 18.8651 14.3837 12.8695 10.843 8.05911Z"
      fill="#FFA300"
    />
    <path
      d="M12.9075 0.00932842C8.99182 0.220662 5.43058 3.78029 5.32717 7.60717C5.19889 12.3544 7.5096 16.1645 9.97414 20.0781C12.4387 23.9917 14.729 22.8729 16.2542 19.0519C16.8796 17.485 19.4292 11.6426 19.0884 6.43941C18.7115 0.685291 14.9585 -0.102976 12.9075 0.00932842Z"
      fill="#FFCC00"
    />
    <path
      d="M20.4702 13.3181C22.6002 11.9525 25.2434 13.9876 23.6062 16.4518C22.6959 17.8219 21.5146 18.7169 20.4614 19.2924C19.24 19.9597 18.0284 18.9057 18.3436 17.5647C18.7299 15.9213 19.3941 14.0081 20.4702 13.3181Z"
      fill="#FF0099"
    />
    <path
      d="M5.92208 5.02344C7.64412 5.21401 9.43761 6.15027 10.843 8.05957C14.3835 12.8697 14.8166 18.8645 14.7639 20.4082C14.7321 21.339 14.3546 22.1664 13.5705 22.4336C12.4722 22.7755 11.2474 22.0997 9.97482 20.0791C7.51035 16.1656 5.19922 12.3555 5.32736 7.6084C5.35138 6.71935 5.56372 5.84501 5.92208 5.02344Z"
      fill="#FF8200"
    />
  </>
)

export default NewLogoIcon
